import * as React from 'react';
import {Alert} from 'antd';
import * as paths from '../../paths';
import {Link} from 'react-router-dom';
import {Rental, Returnal} from "../../api/dtos/dtos";
import locales from "../../locales";

interface RentalDetailsAlertProps {
  rental: Rental | Returnal;
  rentalTitle: string;
}

class RentalDetailsAlert extends React.Component<RentalDetailsAlertProps, {}> {

  public render(): React.ReactNode {
    const {rental, rentalTitle} = this.props;
    const content = (
      <table>
        <tbody>
        {rental.client &&
            this.row(locales.client, <Link to={paths.viewClientPath(rental.client.id)}>{rental.client.name}</Link>)
        }
        {this.row(rentalTitle, <Link to={paths.viewRentalPath(rental.id)}>{rental.idString}</Link>)}
        </tbody>
      </table>
    );

    return (
      <Alert
        style={{marginTop: 4, marginBottom: 24}}
        message={content}
        type="info"
      />
    );
  }

  private row = (title: string, value: React.ReactNode) => {
    if (!value) {
      return null;
    }
    return (
      <tr>
        <td style={{textAlign: 'right', paddingRight: 8}}><b>{title}</b></td>
        <td>{value}</td>
      </tr>
    );
  };

}

export default RentalDetailsAlert;


// WEBPACK FOOTER //
// ./src/checklist/send/RentalDetailsAlert.tsx